export const TEXTS = {
  CANCEL: 'Отменить',
  NEXT: 'Далее',
  SELECT_AD_TYPE_TITLE: 'Выбор рекламной кампании',
  AUDIO_AD: 'Аудиореклама',
  VIDEO_AD: 'Видеореклама',
};
